import { ORCID_CLIENT_ID, ORCID_CLIENT_SECRET, ORCID_REDIRECT_URI } from './EnvVars';

interface IndexObject {
	[key: string]: string;
}

interface AuthorizeQueryParams extends IndexObject {
	client_id: string;
	redirect_uri: string;
	response_type: string;
	scope: string;
}

interface ExchangeTokenQueryParams extends IndexObject {
	client_id: string;
	client_secret: string;
	code: string;
	grant_type: string;
	redirect_uri: string;
}

interface Data {
  access_token: string;
  expires_in: number;
  name: string;
  orcid: string;
  refresh_token: string;
  scope: string;
  token_type: string;
}

export const useOrcidHelper = () => {

	const redirectToAuthorizeOrcidURL = (): void => {
		const queryParams: AuthorizeQueryParams = {
			client_id: ORCID_CLIENT_ID,
			redirect_uri: ORCID_REDIRECT_URI,
			response_type: 'code',
			scope: '/authenticate',
		};

		const url = new URL('https://orcid.org/oauth/authorize');

		for (const qp in queryParams) {
			url.searchParams.append(qp, queryParams[qp] as string);
		}

		window.location.href = url.toString();
	};

	const redirectToAuthorizeOAuthURL = (): void => {
		const queryParams: AuthorizeQueryParams = {
			client_id: ORCID_CLIENT_ID,
			redirect_uri: `${ORCID_REDIRECT_URI}/#/my-profile?`,
			response_type: 'token',
			scope: 'openid',
		};

		const url = new URL('https://orcid.org/oauth/authorize');

		for (const qp in queryParams) {
			url.searchParams.append(qp, queryParams[qp] as string);
		}

		window.location.href = url.toString();
	};

	const exchangeToken = async (code: string): Promise<Response> => {
		const queryParams: ExchangeTokenQueryParams = {
			client_id: ORCID_CLIENT_ID,
			client_secret: ORCID_CLIENT_SECRET,
			code,
			grant_type: 'authorization_code',
			redirect_uri: ORCID_REDIRECT_URI,
			scope: '/read-public'
		};

		const url = new URL('https://orcid.org/oauth/token');

		for (const qp in queryParams) {
			url.searchParams.append(qp, queryParams[qp] as string);
		}

		return await fetch(url.toString(), {
			headers: {
				'Accept': '*',
				'Access-Control-Allow-Origin': '*',
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			method: 'post'
		});
	};

	const fetchExchangeToken = async (code: string): Promise<void> => {
      if (code !== '') {
        // This Works But No Response Is Provided ???? CORS I Think
        const response = await exchangeToken(code);
        const data = await response.json() as Data;

				console.log(data);
        const headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('Authorization', `Bearer ${data.access_token}`);
        headers.append('Content-Type', 'application/json');
        headers.append('Access-Control-Allow-Origin', '*');
      }
    };

	const getPublicAccessToken = async (): Promise<Response> => {
		const queryParams: { [key: string]: string } = {
			client_id: ORCID_CLIENT_ID,
			client_secret: ORCID_CLIENT_SECRET,
			grant_type: 'client_credentials',
			redirect_uri: ORCID_REDIRECT_URI,
			scope: '/read-public'
		};

		const url = new URL('https://orcid.org/oauth/token');

		for (const qp in queryParams) {
			url.searchParams.append(qp, queryParams[qp] as string);
		}

		return await fetch(url.toString(), {
			headers: {
				'Accept': '*',
				'Access-Control-Allow-Origin': '*',
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			method: 'post'
		});
	};

	const getCodeFromURL = () => {
		const url = new URL(window.location.href.replace('#', ''));
		if (url.search.includes("code")) {
			return url.search.split('=')[1] as string;
		}
		return;
	}

	const getTokenFromURL = () => {
		const replacedUrl = new URL(window.location.href.replace('#', ''));
		const urlSearchParams = replacedUrl.searchParams;
		const token = urlSearchParams.get('access_token');
		return token ;  
	}

	const getUserInfo = async (token: string) => {
		const headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('Authorization', `Bearer ${token}`);
		return await fetch(`https://orcid.org/oauth/userinfo`, {
			headers,
		});
	}

	const getWork = async (orcidId: string) => {
		const headers = new Headers();
		headers.append('Accept', 'application/json');
    headers.append('Content-Type', 'application/json');
		return await fetch(`https://pub.orcid.org/v3.0/${orcidId}/works`, {
			headers
		});
	}

	return {
		exchangeToken,
		fetchExchangeToken,
		getCodeFromURL,
		getPublicAccessToken,
		getTokenFromURL,
		getUserInfo,
		getWork,
		redirectToAuthorizeOAuthURL,
		redirectToAuthorizeOrcidURL,
	}

}